import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { EmulationService } from './../../../../services/seed/emulation.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../../common/shared/lol-logger.service';
const _ = require('lodash');

@Component({
  selector: 'app-emulation-dashboard',
  templateUrl: './emulation-dashboard.component.html',
  styleUrls: ['./emulation-dashboard.component.scss']
})

export class EmulationDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  districtList: any = [];
  filterArray = [];
  attachedAccountsList: any[];
  attachedUserList: any[];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  emulatedUserIdText: string;
  loggedInUserText: string;
  validateEvolveData: any;
  selectedDistrict: any;
  isSetEmulation = false;
  userToEmulateText: string;
  cleanAccount = false;
  constructor(private emulationService: EmulationService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService) { }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      let selectedCom;
      if (this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE)) {
        selectedCom = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE));
      }

      const activeUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (this.validateEvolveData != null && this.headerYear != undefined &&
        this.headerCompany != undefined && activeUser) {
        if (activeUser.isEmulationSet) {
          this.loggedInUserText = activeUser.loggedUserId.toUpperCase() + ' - ' + activeUser.loggedUserName.toUpperCase();
          this.userToEmulateText = '';
          this.emulatedUserIdText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase();
          this.isSetEmulation = true;
        }
        else {
          this.isSetEmulation = false;
          this.loggedInUserText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase() + ' ' + activeUser.lastName.toUpperCase();
          this.emulatedUserIdText = '';
        }
      }
    }
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setEmulationPageHeight();
  }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.clearUserText();
    this.setEvolveAccessData();
    this.getDistrictDDL();
    this.subscription.push(this.broadcastService.on<any>(this.configService.SET_USER_EMULATION).subscribe((data) => {
      this.setEvolveAccessData();
      this.selectedDistrict = new Number();
      this.districtList = [];
      this.getDistrictDDL();
    }));
  }

  // Set Name and user id
  setEvolveAccessData() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const activeUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      if (activeUser) {
        if (!activeUser.evolveAccountRestriction || activeUser.isEmulationOverrideByUserID) {
          this.filterArray = [
            { label: 'Account Name', column: 'accountName' },
            { label: 'Account #', column: 'accounttxt' },
            { label: 'City', column: 'city' },
            { label: 'State / Province', column: 'state' }];
        }
        else {
          this.filterArray = [
            // { label: 'Account Name', column: 'accountName' },
            { label: 'Account #', column: 'account' },
            { label: 'City', column: 'city' },
            { label: 'State / Province', column: 'state' }];
        }

        if (activeUser.isEmulationSet) {
          this.loggedInUserText = activeUser.loggedUserId.toUpperCase() + ' - ' + activeUser.loggedUserName.toUpperCase();
          this.userToEmulateText = '';
          this.emulatedUserIdText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase();
          this.isSetEmulation = true;
        }
        else {
          this.loggedInUserText = activeUser.userId.toUpperCase() + ' - ' + activeUser.firstName.toUpperCase() + ' ' + activeUser.lastName.toUpperCase();
        }
      }
    }
  }

  // Clear user text
  clearUserText() {
    this.attachedAccountsList = [];
    this.attachedUserList = [];
    this.emulatedUserIdText = '';
    this.userToEmulateText = '';
    this.isSetEmulation = false;
    this.selectedDistrict = new Number();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setEmulationPageHeight();
  }

  // set account table height
  setEmulationPageHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.emulationOuter').css('height', tableHeight + 'px');
  }

  // Filter Grid
  filterGrid(e: any) {
    if (e == null) {
      this.attachedAccountsList = [];
      this.attachedUserList = [];
      this.districtList = [];
      this.getDistrictDDL();
      if (!this.cleanAccount) {
        this.userToEmulateText = '';
      }
      return false;
    }

    if (e != null &&
      e.account == null &&
      e.accountName == null &&
      e.state == null &&
      e.city == null) {
      this.attachedAccountsList = [];
      this.attachedUserList = [];
      return false;
    }

    if (e != null) {
      this.loaderService.setLoaderStatus(true);

      this.subscription.push(this.emulationService.getAttachedAccountList(e).subscribe(results => {
        if (results) {
          this.attachedAccountsList = results as any[];
          this.selectedDistrict = new Number();
          this.userToEmulateText = '';
          this.attachedUserList = [];
        }
        this.loaderService.setLoaderStatus(false);
      }, error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      }));
    }

    if (this.cleanAccount) {
      this.cleanAccount = false;
    }
  }

  // Account click operation
  accountClick(e) {
    this.loaderService.setLoaderStatus(true);
    const account = +e;

    this.subscription.push(this.emulationService.getUserIdList(account).subscribe(results => {
      if (results) {
        this.attachedUserList = results as any[];
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // User Id Click
  userIdClick(e) {
    this.userToEmulateText = e;
  }

  // Verify the id is eligible for emulation, If id is verified then set the emulation
  setEmulation() {
    if (this.userToEmulateText == '') {
      this.toastrService.warning('UserID not valid for Emulation');
      return false;
    }
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.emulationService.setEmulation(this.userToEmulateText).subscribe((result: any) => {
      // To to code if user is eligible for emulation
      if (result) {
        if (result.isEmulationSet == true) {
          this.isSetEmulation = true;
          this.broadcastService.broadcast(this.configService.SET_CLEAR_EMULATION, { setEmulation: true });
          //this.loaderService.setLoaderStatus(false);
        }
        else {
          this.emulatedUserIdText = '';
          this.userToEmulateText = '';
          if (result.errors.length > 0) {
            this.toastrService.warning(result.errors[0].error);
            this.loaderService.setLoaderStatus(false);
          }
          //this.loaderService.setLoaderStatus(false);
        }
      }
      
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Clear  emulation
  clearEmulation() {
    this.loaderService.setLoaderStatus(true);

    const companyCode = JSON.parse(localStorage.headerCompanyCode);
    let evolveAccess = undefined;
    evolveAccess = JSON.parse(localStorage.evolveAccess).resultData.find(x => x.userIdCompanyCode == companyCode);
    const userId = evolveAccess.loggedUserId;
    const emulationUserId = evolveAccess.userId;

    this.subscription.push(this.emulationService.clearEmulation(userId, emulationUserId).subscribe(results => {
      this.clearUserText();
      this.broadcastService.broadcast(this.configService.SET_CLEAR_EMULATION, { setEmulation: false });
      //this.loaderService.setLoaderStatus(false);
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Get District
  getDistrictDDL() {
    //this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.emulationService.getDistrictFilter().subscribe(results => {
      this.districtList = results;
      //this.loaderService.setLoaderStatus(false);
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // District Search function
  districtSearchFn(term: string, item: any) {
    //
    term = term.toLocaleLowerCase();
    return (item.id.toLocaleLowerCase().indexOf(term) > -1)
      || (item.data.toLocaleLowerCase().indexOf(term) > -1);
  }

  districtFn($event: string) {
    let list: any;
    list = _.filter(this.districtList, item => item.id == null ? false : item.id.toLocaleLowerCase().indexOf($event) > -1
      || (item.data == null ? false : item.data.toLocaleLowerCase().indexOf($event) > -1));
  }

  // District Search close
  districtSearchOnClose($event) {
    if ($event != null
      && $event.id) {
      this.cleanAccount = true;
      this.attachedAccountsList = [];
      this.attachedUserList = [];
      this.userToEmulateText = $event.id;
    } else {
      this.userToEmulateText = '';
    }
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
